<template>
  <v-navigation-drawer
    id="nav-drawer"
    v-model="isOpen"
    :mobile-breakpoint="0"
    :temporary="$device.isMobile"
    theme="dark"
    density="dense"
  >
    <div
      v-if="$device.isMobile"
      class="nav-spacer-mobile"
    >
      <span class="nav-spacer-icon-mobile">
        <v-btn
          class="mx-2"
          icon
          @click="setDrawer(false)"
        >
          <v-icon icon="fas fa-fas fa-chevron-left" />
        </v-btn>
      </span>
    </div>
    <v-divider v-if="$device.isMobile" />
    <v-list theme="dark">
      <template
        v-for="(link, i) in links"
        :key="link.text"
      >
        <DrawerEntry
          :link="link"
          :index="i"
          :selected-customer="selectedCustomer"
          :is-logged-in="isLoggedIn"
        />
      </template>
    </v-list>
    <v-divider v-if="$device.isMobile" />
  </v-navigation-drawer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DrawerEntry from "./DrawerEntry.vue";
export default defineComponent({
  name: "NavDrawer",
  components: {
    DrawerEntry,
  },
  inject: ["$device"],
  props: {
    showDrawer: Boolean,
    links: Array,
    showingDrawer: Boolean,
    isLoggedIn: Boolean,
    selectedCustomer: Object,
    setDrawer: Function,
  },
  computed: {
    isOpen: {
      get() {
        return this.showingDrawer && this.isLoggedIn;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
});
</script>

<style>
#nav-drawer {
  background-color: rgba(33, 33, 33, 1);
  z-index: 50;
  height: 110vh !important;
  width: 100%;
  display: flex;

.nav-spacer-mobile {
  width: 100%;
  display: flex;
}

.nav-spacer-icon-mobile {
  padding: 8px;
  margin: 8px;
  margin-left: auto;
  margin-right: 0;
}

.v-list-group__items .v-list-item {
  padding-left: 32px;
}

.v-list-item--active {
  color: #039af4;
  --v-theme-overlay-multiplier: 2;
}

.v-list-item:hover {
  color: #039af4;
  --v-theme-overlay-multiplier: 4;
}

.v-list-item__prepend {
  color: white
}

.v-list-item__append {
  color: white
}

.v-list-item-title {
  color: white
}
}
</style>